import React, { useEffect, useState, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { UploadLinkPopupProps } from "../upload-file-popup/upload-popup-props";
import UrlInputField from "./url-input-field";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { websiteUrlRegex,attachmentUrlRegex } from '../../../../app/constants/regexStrings'
import './upload-link-popup.scss'
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const UploadLinkUrlPopup: React.FC<UploadLinkPopupProps> = ({
  title,
  open,
  onCancel,
  onOkay,
  buttonText,
  disable = true,
  leadData,
}) => {
  const initialValues = {
    link: leadData?.link || "",
    fileName: leadData?.fileName || "",
  };
   const theme = useTheme();
   const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // true if screen ≤ 600px

  const validationSchema = Yup.object().shape({
    fileName: Yup.string().required("Name is required"),
    link: Yup.string()
      .matches(attachmentUrlRegex, "Please enter valid URL")
      .required("URL is required"),
  });

  const handleSave = (values: any, resetForm: any) => {
    const trimmedLink = values?.link?.trim?.() || "";
    const hasProtocol = /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(trimmedLink);
    const normalizedLink = trimmedLink
      ? hasProtocol
        ? trimmedLink
        : `https://${trimmedLink.replace(/^\/+/, "")}`
      : trimmedLink;

    onOkay({ ...values, link: normalizedLink });
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="update-popup-wrapper upload-link-url-wrapper"
      slotProps={{
        paper: {
          sx: {
            width: isMobile ? "90%" : "570px", // 90% width on mobile
            maxWidth: "95vw",                  // prevent overflow
            minHeight: isMobile ? "auto" : "280px",
            borderBottomLeftRadius: '30px',
            borderBottomRightRadius: '30px',
            top: 0,  // add spacing from top on mobile
            margin: 0,
            position: "absolute",
          },
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent className="url-form-wrapper">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => handleSave(values, resetForm)}
          enableReinitialize
        >
          {({ isValid, dirty, handleSubmit, setFieldValue, values }) => (
            <Form>
              <DialogContent>
                <UrlInputField
                  type="text"
                  fieldName="link"
                  label="Enter URL"
                  placeholder="Enter or copy URL"
                  optional={false}
                  disabled={false}
                  value={values?.link}
                  onChange={(e: any) => {
                    setFieldValue("link", e?.target?.value)
                  }
                  }
                  isRequired={true}
                />
                <UrlInputField
                  type="text"
                  fieldName="fileName"
                  label="Name"
                  placeholder="Enter name for URL"
                  optional={false}
                  disabled={false}
                  value={values?.fileName}
                  onChange={(e: any) =>
                    setFieldValue("fileName", e?.target?.value)
                  }
                  isRequired={true}
                />
              </DialogContent>
              <DialogActions className="button-wrapper">
                <Button onClick={onCancel} className="cancel-btn" type="button">
                  Cancel
                </Button>
                <Button
                  type="button"
                  disabled={disable || !dirty}
                  onClick={() => handleSubmit()}
                  autoFocus
                  className="update-btn"
                >
                  {buttonText || "Attach"}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default UploadLinkUrlPopup;





